/** Fallback palette when `project.color` is not set (stable per project id). */
const FALLBACK_PALETTE = [
  '#722ed1',
  '#fa8c16',
  '#1890ff',
  '#52c41a',
  '#eb2f96',
  '#13c2c2',
  '#2f54eb',
  '#a0d911',
  '#f5222d',
  '#531dab',
];

export const DEFAULT_PROJECT_COLOR = '#1890ff';

function hashStringToIndex(str) {
  let h = 0;
  const s = String(str);
  for (let i = 0; i < s.length; i += 1) {
    h += s.charCodeAt(i) * (i + 3);
  }
  return Math.abs(h) % FALLBACK_PALETTE.length;
}

/**
 * Resolved hex color for UI (dots, bars, selects).
 * @param {object|null|undefined} projectLike — `{ _id, color? }` or populated project doc
 */
export function getProjectColor(projectLike) {
  if (!projectLike) return DEFAULT_PROJECT_COLOR;
  const raw = projectLike.color;
  if (typeof raw === 'string' && /^#[0-9A-Fa-f]{6}$/i.test(raw.trim())) {
    return raw.trim().toLowerCase();
  }
  const id =
    projectLike._id != null
      ? typeof projectLike._id === 'object' && projectLike._id.toString
        ? projectLike._id.toString()
        : String(projectLike._id)
      : null;
  if (id) return FALLBACK_PALETTE[hashStringToIndex(id)];
  return DEFAULT_PROJECT_COLOR;
}

/** Grey for entries without a project. */
export function getNoProjectColor() {
  return 'rgba(0, 0, 0, 0.22)';
}

/**
 * @param {string|null|undefined} projectId
 * @param {Map<string, object>|undefined} projectsById — map of id -> project doc from list API
 */
export function getProjectColorFromId(projectId, projectsById) {
  if (projectId == null || projectId === '') return getNoProjectColor();
  const key = String(projectId);
  const p = projectsById && projectsById.get(key);
  return getProjectColor(p || { _id: key });
}
